import { CommentWithCreator, PatchCommentOpts, PostCommentOpts } from 'Types/comment';

import { commentPathUrl, createCommentsPathUrl } from '../util/routesUrls';
import { API_URL, enrichedFetch } from './api';

export const createComment = (comment: PostCommentOpts) => {
  return enrichedFetch(`${API_URL}/${createCommentsPathUrl()}`, {
    method: 'POST',
    body: JSON.stringify(comment),
    headers: {
      'Content-Type': 'application/json',
    },
  }) as Promise<CommentWithCreator>;
};

export const updateComment = (comment: PatchCommentOpts) => {
  return enrichedFetch(`${API_URL}/${commentPathUrl(comment.id)}`, {
    method: 'PATCH',
    body: JSON.stringify(comment),
    headers: {
      'Content-Type': 'application/json',
    },
  }) as Promise<CommentWithCreator>;
};

export const deleteComment = (commentId: string) => {
  return enrichedFetch(`${API_URL}/${commentPathUrl(commentId)}`, {
    method: 'DELETE',
  }) as Promise<Comment>;
};
